import SEO from 'app/components/SEO/SEO';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HomePageEvent } from 'store/events/types';
import { VendorPublicInformation } from 'store/vendorSlice/types';
import oveitLogo from '../../../assets/common/oveit-logo.svg';

interface HomePageMetaProps {
  events: HomePageEvent[] | undefined;
  publicInformation: VendorPublicInformation | undefined;
}

const HomePageMeta: React.FC<HomePageMetaProps> = ({
  events,
  publicInformation,
}) => {
  const { t } = useTranslation();

  let pageTitle = t('vendorEventsPage.pageTitleDefault');
  let pageDescription = t('vendorEventsPage.pageDescriptionDefault');

  if (publicInformation?.name) {
    pageTitle = t('vendorEventsPage.pageTitle', {
      vendorName: publicInformation.name,
    });
    pageDescription = t('vendorEventsPage.pageDescription', {
      vendorName: publicInformation.name,
    });
  }

  // update for Ateneu
  if (events && events[0]?.id_seller === 'l7PDAr7y') {
    pageTitle = 'Bilete Ateneul Roman - concerte Filarmonica George Enescu';
  }

  if (publicInformation?.description) {
    pageDescription = publicInformation.description;
  }

  const firstEventWithImage = events?.length
    ? events.find(({ cover }) => cover)
    : undefined;

  const pageImage = firstEventWithImage?.cover?.original || oveitLogo;

  return (
    <SEO
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage={pageImage}
    />
  );
};

export default HomePageMeta;
